import {
    RaikoBaseCardContainer,
    RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoGridTwoColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    convertUniversalDateToPersianDate,
    showServerErrorMessage,
    convertPersianDateToUniversalDate, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {OccasionalService} from "../../../serverService/occasional/OccasionalService";

export default function OccasionalBannerDetailsBasicInfo({bannerId,setCreatedBy, setCreateDate}) {


    const service = new OccasionalService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [title, setTitle] = useState("")
    const [slug, setSlug] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [priority, setPriority] = useState("")
    const [description, setDescription] = useState("");
    const [buttonLoading, setButtonLoading] = useState(false)


    useEffect(() => {
        getBasicInfoFromServer()
    }, [bannerId]);


    function getBasicInfoFromServer() {
        loading.show()

        service.getBannerDetailById(bannerId)
            .then(response => {
                setTitle(response.title)
                setSlug(response.slug)
                setDescription(response.description)
                setStartDate(response.startDate ? convertUniversalDateToPersianDate(response.startDate) : '')
                setEndDate(response.endDate ? convertUniversalDateToPersianDate(response.endDate) : "")
                setPriority(response.priority)
                setCreatedBy(response.createdBy)
                setCreateDate(response.createdAt ? convertUniversalDateToPersianDate(response.createdAt) : "")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })

    }

    function handleUpdateBanner() {
        setButtonLoading(true)
        service.updateDetail(
            bannerId,
            title,
            slug,
            convertPersianDateToUniversalDate(startDate),
            convertPersianDateToUniversalDate(endDate),
            priority,
            description
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setButtonLoading(false)
        })
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"اطلاعات پایه"}
                hasActionButton
                actionButtonLoadingState={buttonLoading}
                actionButtonOnclick={handleUpdateBanner}
            >
                <RaikoGridOneColumn>
                    <RaikoGridThreeColumn>
                        <RaikoSimpleInputOutlined
                            labelText={"عنوان"}
                            setValue={setTitle}
                            value={title}
                        />
                        <RaikoSimpleInputOutlined
                            labelText={"slug"}
                            setValue={setSlug}
                            value={slug}
                        />
                        <RaikoSimpleInputOutlined
                            labelText={"اولویت"}
                            setValue={setPriority}
                            value={priority}
                        />
                    </RaikoGridThreeColumn>
                    <RaikoGridTwoColumn>
                        <RaikoDatePicker
                            label={"تاریخ شروع"}
                            date={startDate}
                            setDate={setStartDate}
                        />
                        <RaikoDatePicker
                            label={"تاریخ پایان"}
                            date={endDate}
                            setDate={setEndDate}
                        />
                    </RaikoGridTwoColumn>

                </RaikoGridOneColumn>

            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}